// extracted by mini-css-extract-plugin
export default {"slider":"AboutUsCarousel_slider__CydBK","slide":"AboutUsCarousel_slide__iWhMw"};